/**
 * Canonical link to an issue's drawer (`/issues?issueId=...`) — shared by
 * every surface that links to an issue by id (flow list chip, node pill,
 * failure diagnostics, run detail RCA). Kept as one tiny helper so the URL
 * shape lives in exactly one place.
 *
 * @module utils/issueLinks
 */
export function issueHref(issueId: string): string {
  return `/issues?issueId=${issueId}`;
}
